export enum PostHogExperiment {
	CONTROL = 'control',
	SOPHIA_ENTRY_POINT_VARIANT_A = 'sophia-entry-point-variant-a',
	SOPHIA_ENTRY_POINT_VARIANT_B = 'sophia-entry-point-variant-b'
}